import { render, staticRenderFns } from "./CreateRoutine.vue?vue&type=template&id=2c05adcf"
import script from "./CreateRoutine.vue?vue&type=script&lang=js"
export * from "./CreateRoutine.vue?vue&type=script&lang=js"
import style0 from "./CreateRoutine.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports